"use client"

import { memo } from 'react'
import Link from 'next/link'
import { catColor } from '@/lib/catColors'

const CategoryUnderline = ({ name, label, url, viewAll = true }) => {
    return (
        <div
            className="flex items-center justify-between pb-2 mb-3.5 gap-3 border-b-[3px]"
            style={{ borderColor: catColor(name) }}
        >
            <h3 className="mr m-0 text-lg sm:text-xl font-bold text-(--text-primary)">
                {label || name}
            </h3>
            {viewAll && (
                <Link
                    href={url || '/'}
                    className="mr text-[11px] sm:text-[12px] font-semibold no-underline cursor-pointer whitespace-nowrap shrink-0"
                    style={{ color: catColor(name) }}
                >
                    सर्व पहा →
                </Link>
            )}
        </div>
    )
}

export default memo(CategoryUnderline)